import ImageInfo from './ImageInfo';

export default ImageInfo;
